module.exports = __webpack_public_path__ + "static/media/join-slate.790a7e8e.png";